import { URLS } from '@/configs/urls'

function normalizePathname(pathname: string): string {
  const withoutQuery = pathname.split('?')[0] ?? pathname
  if (withoutQuery.length > 1 && withoutQuery.endsWith('/')) {
    return withoutQuery.slice(0, -1)
  }
  return withoutQuery
}

function isClubsAreaPath(pathname: string): boolean {
  const path = normalizePathname(pathname)
  return path === URLS.CLUBS || path.startsWith(`${URLS.CLUBS}/`)
}

/**
 * Club owners live on `/clubs/{id}` (and related `/clubs/*` flows) as their
 * cabinet. After logout those pages stay public for guests — send the club
 * account home instead of leaving them on their own public profile.
 * Fans logging out from a public club page stay put.
 */
export function shouldRedirectHomeOnClubLogout(
  pathname: string | null | undefined,
  isClubUser: boolean
): boolean {
  if (!isClubUser || !pathname) {
    return false
  }

  return isClubsAreaPath(pathname)
}
